export default __webpack_public_path__ + "static/media/cleaning_responsive.da46b76b.png";